import { render, staticRenderFns } from "./CaseERPView.vue?vue&type=template&id=207b278b"
import script from "./CaseERPView.vue?vue&type=script&lang=js"
export * from "./CaseERPView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports